export enum ChaveContratoEnum {
    CONTRATO_INDICAR_APP = "indicar_app",

    CONTRATO_RECOMENDACAO_ACOES = "recomendacao_acoes",
    CONTRATO_RECOMENDACAO_CRIPTOMOEDAS = "recomendacao_criptomoedas",
    CONTRATO_RECOMENDACAO_FUNDOS_IMOBILIARIOS = "recomendacao_fiis",
    CONTRATO_RECOMENDACAO_FUNDOS_INDICES = "recomendacao_etfs",
    CONTRATO_RECOMENDACAO_INDICES = "recomendacao_indices",
    CONTRATO_RECOMENDACAO_EUA = "recomendacao_eua",
    CONTRATO_RECOMENDACAO_BDR = "recomendacao_bdr",
    CONTRATO_RECOMENDACAO_OPCOES_BRASIL = "recomendacao_opcoes_brasil",

    CONTRATO_ANALISE_ACOES = "analise_acoes",
    CONTRATO_ANALISE_CRIPTOMOEDAS = "analise_criptomoedas",
    CONTRATO_ANALISE_FUNDOS_IMOBILIARIOS = "analise_fiis",
    CONTRATO_ANALISE_FUNDOS_INDICES = "analise_etfs",
    CONTRATO_ANALISE_INDICES = "analise_indices",
    CONTRATO_ANALISE_EUA = "analise_eua",
    CONTRATO_ANALISE_BDR = "analise_bdr",

    CONTRATO_PRISMA_ACOES = "prisma_acoes",
    CONTRATO_PRISMA_CRIPTOMOEDAS = "prisma_criptomoedas",
    CONTRATO_PRISMA_FUNDOS_IMOBILIARIOS = "prisma_fiis",
    CONTRATO_PRISMA_FUNDOS_INDICES = "prisma_etfs",
    CONTRATO_PRISMA_INDICES = "prisma_indices",
    CONTRATO_PRISMA_EUA = "prisma_eua",
    CONTRATO_PRISMA_BDR= "prisma_bdr",
    
    CONTRATO_AREA_PLANOS = "area_planos",

    CONTRATO_FORMULARIO_TRADER = "formulario_trader",

    CONTRATO_CARTEIRA_RECOMENDADA = "giro_rapido_cripto"
}